import React from 'react';
import { BRAND } from '../../constants/main';
import { BreadcrumbsAC } from './AC/Breadcrumbs.AC';
import { BreadcrumbsOV } from './OV/Breadcrumbs.OV';
import { BreadcrumbsAP } from './AP/Breadcrumbs.AP';
import { BreadcrumbsDS } from './DS/Breadcrumbs.DS';
import { BreadcrumbsStyled } from './BreadcrumbsStyled';
import { SC } from '../../styles/theme';
import { IBreadcrumbItem } from '../../redux/commonDucks/ui.duck.interface';

export interface BreadcrumbProps extends SC {
    items: IBreadcrumbItem[];
}

const Breadcrumbs = (props: BreadcrumbProps) => {
    if (BRAND === 'AC') return <BreadcrumbsAC {...props} />;
    if (BRAND === 'OV') return <BreadcrumbsOV {...props} />;
    if (BRAND === 'AP') return <BreadcrumbsAP {...props} />;
    if (BRAND === 'DS') return <BreadcrumbsDS {...props} />;
    return <BreadcrumbsStyled {...props} />;
};

export default Breadcrumbs;
